import styles from "src/styles/components/elements/skeleton.module.scss";

const widthClasses = {
  75: styles.width75,
  78: styles.width78,
  120: styles.width120,
  150: styles.width150,
  200: styles.width200,
  600: styles.width600,
};

const heightClasses = {
  78: styles.height78,
};

const Skeleton = ({ count = 1, width, height }) => {
  const skeletonClassName = [
    styles.skeleton,
    widthClasses[width],
    heightClasses[height],
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={styles.container} aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <span className={skeletonClassName} key={index} />
      ))}
    </span>
  );
};

export default Skeleton;
